import { useCallback, useEffect, useState } from 'react'
import { fetchActiveSubscription, fetchPaymentMethods } from '~/service/Billing/fetchApiClient'

// The AppContext an announcement's PlansDialog needs. Inside AdminLayout the page already
// holds that state, so its context is handed straight back; mounted standalone from a legacy
// layout nothing provides it and the announcement owns its own copy.
//
// renderToken rides along on both paths - ChangePlanDialog reads it off here to attribute
// the upgrade. A page's own context never carries one.
export const useAnnouncementBilling = (appContext, { enabled, renderToken = null }) => {
  const { company, jwt, csrf } = appContext
  const hasBillingContext = typeof appContext.setPaymentMethods === 'function'

  const [subscription, setSubscription] = useState(appContext.subscription ?? null)
  const [paymentMethods, setPaymentMethods] = useState(appContext.paymentMethods ?? [])

  const refreshSubscription = useCallback(async () => {
    setSubscription(await fetchActiveSubscription(company.id, jwt))
  }, [company?.id, jwt])

  const refreshPaymentMethods = useCallback(async () => {
    const { data } = await fetchPaymentMethods(company.id, jwt, csrf)
    setPaymentMethods(data ?? [])
  }, [company?.id, jwt, csrf])

  useEffect(() => {
    if (hasBillingContext || !enabled || !company) return

    Promise.all([refreshSubscription(), refreshPaymentMethods()]).catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasBillingContext, enabled, company?.id])

  if (hasBillingContext) return { ...appContext, announcementRenderToken: renderToken }

  return {
    ...appContext,
    announcementRenderToken: renderToken,
    subscription,
    paymentMethods,
    setPaymentMethods,
    refreshPaymentMethods,
    refreshSubscription,
  }
}
